import { render } from "./TextListRenderer.vue?vue&type=template&id=def4eea4&scoped=true"
const script = {}

import "./TextListRenderer.vue?vue&type=style&index=0&id=def4eea4&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def4eea4"]])

export default __exports__